import { LicenseLimitExceededReasons } from "../constant";

export const licenseLimitExceededReason = {
  type: "string",
  enum: [...Object.values(LicenseLimitExceededReasons)]
};
